export default __webpack_public_path__ + "static/media/ownership.1a82db79.svg";